<template>
  <v-container fill-height fluid class="pt-0 pb-0">
    <v-row class="chat-container d-flex justify-center">
      <v-col cols="12">
        <v-row :class="[{'mh20': windowHeight <= 1080}, {'mh10': windowHeight > 1080}]">
          <v-col cols="12">
            <v-card class="fill-height">
              <v-card-text class="fill-height">
                <v-row>
                  <v-col cols="6" :class="['d-flex align-center justify-center', {'selected': !showdown}]" style="cursor: pointer" @click="showdown=false">
                    <h3>Mining v2</h3>
                  </v-col>
                  <v-col cols="6" :class="['d-flex align-center justify-center', {'selected': showdown}]" style="cursor: pointer" @click="showdown=true">
                    <h3>Showdown</h3>
                  </v-col>
                </v-row>

                <v-row class="fill-height d-flex justify-center align-center mt-0">
                  <v-col cols="12" class="d-flex justify-center align-center">
                    <template v-if="!showdown">
                      <v-btn color="primary" @click="loadRandomMessages" :disabled="!mined || showdown">general table chat</v-btn>
                    &nbsp;&nbsp;<v-btn color="primary" @click="loadV2Mining('huge_pot')" :disabled="!mined || showdown">huge pot</v-btn>
                    &nbsp;&nbsp;<v-btn color="primary" @click="loadV2Mining('stood_up')" :disabled="!mined || showdown">stood up</v-btn>
                    &nbsp;&nbsp;<v-btn color="primary" @click="loadV2Mining('sat_down')" :disabled="!mined || showdown">sat down</v-btn>
                    &nbsp;&nbsp;<v-btn color="primary" @click="loadV2Mining('interesting_hand')" :disabled="!mined || showdown">interesting hand</v-btn>
                    </template>
                    <template v-else>
                      <v-row class="d-flex justify-center align-center">
                        <v-col cols="2" lg="3" md="2" class="d-flex justify-center align-center">
                          <v-select
                              :items="showdownTypes"
                              v-model="selectedShowdownFilter"
                              outlined
                              hide-details
                              label="Showdown Filter"
                              item-type="text"
                              item-value="value"
                              @change="filterChanged"
                          >
                            <template v-slot:selection="{ item }">
                              <v-btn icon @click.stop="editShowdownFilter(item)">
                                <v-icon small>mdi-pencil</v-icon>
                              </v-btn>
                              <span>
                                {{ item.text }}<span style="color: gray"> - {{ item.description }}</span>
                              </span>
                            </template>
                            <template v-slot:item="{ item }">
                              <span>
                                {{ item.text }}<span style="color: gray"> - {{ item.description }}</span>
                              </span>
                            </template>
                          </v-select>
                        </v-col>
                        <v-col cols="1" lg="1" md="1" class="d-flex justify-center align-center">
                          <v-select label="Interesting Hands" :items="interestingHandsOptions" outlined hide-details v-model="showdownInterestingHands" @change="filterUpdated"></v-select>
                        </v-col>
                        <v-col cols="2" lg="1" md="2" class="d-flex justify-center align-center">
                          <v-text-field label="Pot Size Min" outlined hide-details v-model="showdownPotSizeMin" type="number" @change="filterUpdated"></v-text-field>
                          <v-text-field label="Pot Size Max" outlined hide-details v-model="showdownPotSizeMax" type="number" class="ml-2" @change="filterUpdated"></v-text-field>
                        </v-col>
                        <v-col cols="3" lg="2" md="3" class="d-flex justify-center align-center">
                          <v-select label="Hand Winner Strength Min" :items="handStrengthOptions" item-value="min" outlined hide-details v-model="showdownWinnerStrengthMin" @change="filterUpdated"></v-select>
                          <v-select label="Hand Winner Strength Max" :items="handStrengthOptions" item-value="max" outlined hide-details v-model="showdownWinnerStrengthMax" class="ml-2" @change="filterUpdated"></v-select>
                        </v-col>
                        <v-col cols="3" lg="2" md="3" class="d-flex justify-center align-center">
                          <v-select label="Hand Loser Strength Min" :items="handStrengthOptions" item-value="min" outlined hide-details v-model="showdownLoserStrengthMin" @change="filterUpdated"></v-select>
                          <v-select label="Hand Loser Strength Max" :items="handStrengthOptions" item-value="max" outlined hide-details v-model="showdownLoserStrengthMax" class="ml-2" @change="filterUpdated"></v-select>
                        </v-col>
                        <v-col cols="1" lg="1" md="1" class="d-flex justify-center align-center">
                          <v-select label="Game Type" :items="gameTypeOptions" outlined hide-details v-model="showdownGameType" @change="filterUpdated"></v-select>
                        </v-col>
                        <v-col cols="2" lg="1" md="2" class="d-flex justify-center align-center">
                        &nbsp;&nbsp;<v-btn color="primary" @click="loadV2Mining('showdown')">Filter Showdown</v-btn>
                        </v-col>
                      </v-row>
                    </template>
                  </v-col>
                </v-row>

              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row :class="[{'mh70': windowHeight <= 1080}, {'mh80': windowHeight > 1080}]">
          <v-col cols="6" style="overflow: auto; height: 100%">
            <chat-history ref="chatHistory"
                          @action="loadAfterAction" @onScroll="updateDone" @onMessages="updateDone" @loadHand="loadHand"
                          :messages="messages" :displayID="displayID" :addSuggestion="true" :isShowdown="showdown" :showdownFilters="showdownFilters"></chat-history>
          </v-col>
          <v-col cols="6" style="height: 100%">
            <template v-if="showdown">
              <v-row :class="[{'mh20': windowHeight <= 1080}, {'mh10': windowHeight > 1080}]">
                <v-col cols="12">
                  <v-card style="height: 100%">
                    <v-card-text v-if="stats && stats.showdowns_count">
                      <h3>[*] Frequency of Showdown Type: {{ formatNumber((stats.showdowns_filter_count / (stats.showdowns_count || 1)) * 100) }}% ({{ stats.showdowns_filter_count || 0 }}/{{ stats.showdowns_count || 0 }})</h3>
                      <h3>[*] Frequency has Chat: {{ formatNumber((stats.showdowns_filter_chat_count / (stats.showdowns_filter_count || 1)) * 100) }}% ({{ stats.showdowns_filter_chat_count || 0 }}/{{ stats.showdowns_filter_count || 0 }})</h3>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <v-row :class="[{'mh80': windowHeight <= 1080}, {'mh90': windowHeight > 1080}]" style="overflow: auto; margin: 24px 0px 0px 0px;">
                <v-col cols="12" class="ma-0 pa-0">
                  <mining-table :hand="handData" @loadHand="loadHand" :colsFit="windowHeight <= 1080 ? 8 : 6"></mining-table>
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <mining-table :hand="handData" @loadHand="loadHand" :colsFit="6"></mining-table>
            </template>
          </v-col>
        </v-row>
        <v-row class="mh10">
          <v-col cols="12" class="pa-0 d-flex justify-center align-center">
            <template v-if="!showdown">
              <v-btn color="primary" :disabled="!canMarkDone" @click="askDone=true">Done</v-btn>
              <v-btn color="red" @click="clearPage" class="ml-2">Clear</v-btn>
            </template>
            <template v-else>
              <v-btn color="primary" :disabled="mined" @click="loadV2Mining('showdown')">Get a new one</v-btn>
              <v-btn color="green" :disabled="mined" @click="loadV2Mining('showdown', true)" class="ml-2">Get a new one with chat</v-btn>
              <v-btn color="primary" :disabled="mined" @click="askDone=true" class="ml-2">Done</v-btn>
            </template>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row :class="['panel', {'panel-open': isOpen}, {'panel-closed': !isOpen}]">
      <div class="panel-action d-flex justify-center align-center" style="cursor: pointer" @click="isOpen=!isOpen">
        <v-icon v-if="isOpen">mdi-arrow-right</v-icon>
        <v-icon v-if="!isOpen">mdi-arrow-left</v-icon>
      </div>
      <v-col cols="12" style="overflow-y: scroll; height: 100%">
        <v-row>
          <v-col cols="12" class="mh50 d-flex justify-center align-center" style="margin: auto;">
            <v-data-table
                :headers="headersSuggestions"
                :items="suggestions"
                :loading="loadingSuggestions"
                style="width: 100%"
            >
              <template v-slot:top>
                <div class="d-flex pa-5">
                  <v-toolbar-title>
                    <span>Unverified Suggestions</span>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" small @click="verifyAllSuggestions">Verify All</v-btn>
                </div>
              </template>

              <template v-slot:item.game_type="{ item }">
                <v-chip label v-for="type of item.game_type" :key="type" class="mr-2">{{ type }}</v-chip>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-icon
                    color="green darken-1"
                    small
                    @click="verifySuggestion(item)"
                    class="mr-2"
                >
                  mdi-check
                </v-icon>
                <v-icon
                    color="blue darken-1"
                    small
                    @click="openEditSuggestion(item)"
                    class="mr-2"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                    color="red darken-1"
                    small
                    @click="deleteSuggestion(item)"
                >
                  mdi-delete
                </v-icon>
              </template>

            </v-data-table>
          </v-col>

          <v-col cols="12" class="mh50 pt-0 d-flex justify-center align-center">
            <v-data-table
                :headers="headersTriggers"
                :items="triggers"
                :loading="loadingTriggers"
                style="width: 100%"
            >
              <template v-slot:top>
                <div class="d-flex pa-5">
                  <v-toolbar-title>
                    <span>Unverified Triggers</span>
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" small @click="verifyAllTriggers">Verify All</v-btn>
                </div>
              </template>

              <template v-slot:item.game_type="{ item }">
                <v-chip label v-for="type of item.game_type" :key="type" class="mr-2">{{ type }}</v-chip>
              </template>

              <template v-slot:item.actions="{ item }">
                <v-icon
                    color="green darken-1"
                    small
                    @click="verifyTrigger(item)"
                    class="mr-2"
                >
                  mdi-check
                </v-icon>
                <v-icon
                    color="blue darken-1"
                    small
                    @click="openEditTrigger(item)"
                    class="mr-2"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                    color="red darken-1"
                    small
                    @click="deleteTrigger(item)"
                >
                  mdi-delete
                </v-icon>
              </template>
            </v-data-table>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-dialog v-model="askDone" width="500">
      <v-card>
        <v-card-title>Confirm Done?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="askDone=false">Cancel</v-btn>
          <v-btn color="green" text @click="markMined(); askDone=false">Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="askEditType" width="500">
      <v-card>
        <v-card-title>Edit Filter Name</v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12" class="d-flex justify-center align-center">
              Editing filter name for: <strong>{{ editType.text }}</strong>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="d-flex justify-center align-center" v-if="editType">
              <v-text-field label="Name" v-model="editType.name" outlined hide-details></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="askEditType=false">Cancel</v-btn>
          <v-btn color="green" text @click="editFilter(); askEditType=false">Done</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="askVerifyTrigger" width="500">
      <v-card>
        <v-card-title>
          Verify Trigger?
        </v-card-title>
        <v-card-text>
          <v-list-item>
            <span>Type: {{ verifyingTrigger.type }}</span>
          </v-list-item>
          <v-list-item>
            <span>Game Type: {{ verifyingTrigger.game_type }}</span>
          </v-list-item>
          <v-list-item>
            <span>Trigger: {{ verifyingTrigger.trigger }}</span>
          </v-list-item>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="askVerifyTrigger=false">Cancel</v-btn>
          <v-btn color="green" text @click="verifyTrigger(); askVerifyTrigger=false">Verify</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="askVerifySuggestion" width="500">
      <v-card>
        <v-card-title>
          Verify Suggestion?
        </v-card-title>
        <v-card-text>
          <v-list-item>
            <span>Type: {{ verifyingSuggestion.type }}</span>
          </v-list-item>
          <v-list-item>
            <span>Game Type: {{ verifyingSuggestion.game_type }}</span>
          </v-list-item>
          <v-list-item>
            <span>Suggestion: {{ verifyingSuggestion.suggestion }}</span>
          </v-list-item>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="askVerifySuggestion=false">Cancel</v-btn>
          <v-btn color="green" text @click="verifySuggestion(); askVerifySuggestion=false">Verify</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="askDeleteTrigger" width="500">
      <v-card>
        <v-card-title>
          Delete Trigger
        </v-card-title>
        <v-card-text>
          <v-list-item>
            <span>Type: {{ deletingTrigger.type }}</span>
          </v-list-item>
          <v-list-item>
            <span>Game Type: {{ deletingTrigger.game_type }}</span>
          </v-list-item>
          <v-list-item>
            <span>Trigger: {{ deletingTrigger.trigger }}</span>
          </v-list-item>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="askDeleteTrigger=false">Cancel</v-btn>
          <v-btn color="green" text @click="deleteTrigger(); askDeleteTrigger=false">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="askDeleteSuggestion" width="500">
      <v-card>
        <v-card-title>
          Delete Suggestion
        </v-card-title>
        <v-card-text>
          <v-list-item>
            <span>Type: {{ deletingSuggestion.type }}</span>
          </v-list-item>
          <v-list-item>
            <span>Game Type: {{ deletingSuggestion.game_type }}</span>
          </v-list-item>
          <v-list-item>
            <span>Suggestion: {{ deletingSuggestion.suggestion }}</span>
          </v-list-item>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="askDeleteSuggestion=false">Cancel</v-btn>
          <v-btn color="green" text @click="deleteSuggestion(); askDeleteSuggestion=false">Confirm</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="askEditSuggestion" width="500">
      <v-card>
        <v-card-title>
          Edit Suggestion
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-select
                  :items="suggestionTypes"
                  v-model="editingSuggestion.type"
                  outlined
                  hide-details
                  label="Type"
              >
                <template v-slot:selection="{ item }">
                  <span>
                    {{ item.text }}<span style="color: gray"> - {{ item.description }}</span>
                  </span>
                </template>
                <template v-slot:item="{ item }">
                  <span>
                    {{ item.text }}<span style="color: gray"> - {{ item.description }}</span>
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                  :items="selectGameTypes"
                  v-model="editingSuggestion.game_type"
                  outlined
                  hide-details
                  multiple
                  label="Game Type"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  v-model="editingSuggestion.suggestion"
                  label="Suggestion"
                  outlined
                  hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="editSuggestion(); askEditSuggestion=false" :disabled="!isValidEdit()">Confirm</v-btn>
          <v-btn text @click="askEditSuggestion=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="askEditTrigger" width="500">
      <v-card>
        <v-card-title>
          Edit Trigger
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-select
                  :items="suggestionTypes"
                  v-model="editingTrigger.type"
                  outlined
                  hide-details
                  label="Type"
              >
                <template v-slot:selection="{ item }">
                  <span>
                    {{ item.text }}<span style="color: gray"> - {{ item.description }}</span>
                  </span>
                </template>
                <template v-slot:item="{ item }">
                  <span>
                    {{ item.text }}<span style="color: gray"> - {{ item.description }}</span>
                  </span>
                </template>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-select
                  :items="selectGameTypes"
                  v-model="editingTrigger.game_type"
                  outlined
                  hide-details
                  multiple
                  label="Game Type"
              ></v-select>
            </v-col>
            <v-col cols="12">
              <v-text-field
                  v-model="editingTrigger.trigger"
                  label="Trigger (case insensitive)"
                  outlined
                  hide-details
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green" text @click="editTrigger(); askEditTrigger=false" :disabled="!isValidEditTrigger()">Confirm</v-btn>
          <v-btn text @click="askEditTrigger=false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ChatHistory from "./ChatHistory";
import axios from "axios";
import MiningTable from "./MiningTable";
export default {
  name: "MiningPage",
  components: {MiningTable, ChatHistory},

  data() {
    return {
      tab: 0,

      showdown: false,
      showdownInterestingHands: -1,
      interestingHandsOptions: [
        { text: "All", value: -1 },
        { text: "Only Interesting Hands", value: 1 },
        { text: "Only Non Interesting Hands", value: 0 },
      ],
      showdownPotSizeMin: 0,
      showdownPotSizeMax: 100,
      showdownWinnerStrengthMin: 10001,
      showdownWinnerStrengthMax: -1,
      showdownLoserStrengthMin: 10001,
      showdownLoserStrengthMax: -1,
      handStrengthOptions: [
        { text: "Any", min: 10001, max: -1 },
        { text: "Straight Flush", min: 10, max: 0},
        { text: "Four of a Kind", min: 166, max: 11},
        { text: "Full House", min: 322, max: 167},
        { text: "Flush", min: 1599, max: 323},
        { text: "Straight", min: 1609, max: 1600},
        { text: "Three of a Kind", min: 2467, max: 1610},
        { text: "Two Pair", min: 3325, max: 2468},
        { text: "Pair", min: 6185, max: 3326},
        { text: "High Card", min: 7462, max: 6186},
      ],
      gameTypeOptions: [
        { text: "Any", value: "any" },
        { text: "NLH", value: "nlh" },
        { text: "PLO", value: "plo4" },
        { text: "PLO 5", value: "plo5" },
      ],
      showdownGameType: "any",

      stats: {},

      messages: [],
      displayID: "",
      roomId: "",

      isOpen: false,

      mined: true,
      mining_type: null,
      v2_target_id: null,

      askDone: false,

      headersSuggestions: [
        { text: 'Type', value: 'type' },
        { text: 'Game Type', value: 'game_type' },
        { text: 'Suggestion', value: 'suggestion' },
        { text: 'Actions', value: 'actions' }
      ],
      suggestions: [],
      loadingSuggestions: false,

      headersTriggers: [
        { text: 'Type', value: 'type' },
        { text: 'Game Type', value: 'game_type' },
        { text: 'Trigger', value: 'trigger' },
        { text: 'Actions', value: 'actions' }
      ],
      triggers: [],
      loadingTriggers: false,

      askEditType: false,
      editType: {},

      askVerifyTrigger: false,
      askDeleteTrigger: false,

      askVerifySuggestion: false,
      askDeleteSuggestion: false,

      verifyingTrigger: {},
      deletingTrigger: {},

      verifyingSuggestion: {},
      deletingSuggestion: {},

      editingTrigger: {},
      editingSuggestion: {},

      askEditTrigger: false,
      askEditSuggestion: false,

      selectGameTypes: [
        'ofc',
        'nlh',
        'plo',
        'plo5c',
        'plo6c',
      ],

      suggestionTypes: [],

      canMarkDone: false,
      handData: {},

      windowHeight: window.innerHeight,

      selectedShowdownFilter: null,
    }
  },

  computed: {
    showdownFilters() {
      let isIH = null;

      if (this.showdownInterestingHands === 1) {
        isIH = true;
      } else if (this.showdownInterestingHands === 0) {
        isIH = false;
      }

      return {
        is_interesting_hand: isIH,
        pot_size_min: this.showdownPotSizeMin,
        pot_size_max: this.showdownPotSizeMax,
        winner_strength_min: this.showdownWinnerStrengthMin,
        winner_strength_max: this.showdownWinnerStrengthMax,
        loser_strength_min: this.showdownLoserStrengthMin,
        loser_strength_max: this.showdownLoserStrengthMax,
        game_type: this.showdownGameType
      }
    },

    showdownTypes() {
      let filters = [{
        text: "New Filter",
        description: "Current filter still not saved",
        value: null,
      }];
      return filters.concat(this.suggestionTypes.filter(
          el => el.is_showdown
      ));
    }
  },

  mounted() {
    this.loadSuggestions();
    this.loadSuggestionsTriggers();
    this.loadSuggestionTypes();

    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    onResize() {
      this.windowHeight = window.innerHeight
    },

    formatNumber(v, _d=2) {
      if (!v) return v;
      return (v).toFixed(_d).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },

    clearPage() {
      this.mined = false;
      this.messages = [];
      this.handData = {};
    },

    loadSuggestions() {
      this.loadingSuggestions = true;
      this.$axios.get("/api/suggestions?type=unverified").then((res) => {
        const data = res.data;

        this.suggestions = data.suggestions;

        this.loadingSuggestions = false;
      }).catch((err) => {
        console.error(err);
      })
    },

    loadSuggestionsTriggers() {
      this.loadingTriggers = true;
      this.$axios.get("/api/suggestions/triggers?type=unverified").then((res) => {
        const data = res.data;

        this.triggers = data.triggers;

        this.loadingTriggers = false;
      }).catch((err) => {
        console.error(err);
      })
    },

    _markMined_v1() {
      let url = `/api/unmined_chat`;

      const payload = {
        roomId: this.roomId,
        displayID: this.displayID
      }

      this.$axios.post(url, payload).then((res) => {
        const data = res.data;
        if (data.success) {
          this.mined = true;

          this.loadRandomMessages();

          this.loadSuggestionsTriggers();
          this.loadSuggestions();
        }
      }).catch((err) => {
        console.error(err);
      })
    },

    markMined() {
      if (this.mining_type === 'chats_v1') {
        return this._markMined_v1();
      }

      let url = `/api/unmined_v2/done`;

      const payload = {
        targetId: this.v2_target_id,
      };

      this.$axios.post(url, payload).then((res) => {
        const data = res.data;
        if (data.success) {
          this.mined = true;

          // load another of same type
          this.loadV2Mining(this.mining_type);

          // update stuff on the right
          this.loadSuggestionsTriggers();
          this.loadSuggestions();
        }
      }).catch((err) => {
        console.error(err);
      })
    },

    loadRandomMessages() {
      let url = `/api/unmined_chat`;

      this.mining_type = 'chats_v1';

      this.$axios.get(url).then((res) => {
        const data = res.data;

        this.displayID = data.displayID;
        this.roomId = data.roomId;

        this.mined = false;
        this.messages = [];

        for (let message of data.messages) {
          this.addMessage(this.messages, message);
        }

        if (!this.messages.length) {
          this.mined = true;
        }

      }).catch((err) => {
        console.error(err);
      })
    },

    loadV2Mining(mining_type, withChat=false) {
      let url = `/api/unmined_v2/${mining_type}?`;

      this.mining_type = mining_type;

      if (mining_type === "showdown") {
        url += `interesting_hand=${this.showdownInterestingHands}&`;
        url += `pot_size_min=${this.showdownPotSizeMin}&`;
        url += `pot_size_max=${this.showdownPotSizeMax}&`;
        url += `winner_strength_min=${this.showdownWinnerStrengthMin}&`;
        url += `winner_strength_max=${this.showdownWinnerStrengthMax}&`;
        url += `loser_strength_min=${this.showdownLoserStrengthMin}&`;
        url += `loser_strength_max=${this.showdownLoserStrengthMax}&`;
        url += `game_type=${this.showdownGameType}&`;

        if (withChat) {
          url += `with_chat=1`;
        }
      }

      this.$axios.get(url).then((res) => {
        const data = res.data;

        this.displayID = data.displayID;
        this.roomId = data.roomId;

        this.mined = false;
        this.messages = [];

        this.stats = data.stats;

        for (let message of data.before) {
          this.addMessage(this.messages, message);
        }

        this.messages.push({type: 'marker', marker: true});
        this.addMessage(this.messages, data.target);
        this.messages.push({type: 'marker', marker: true});

        this.v2_target_id = data.target_id;

        for (let message of data.after) {
          this.addMessage(this.messages, message);
        }

        setTimeout(() => {
          this.$refs.chatHistory.scrollToMarker();
        }, 0);

        if (!this.messages.length) {
          this.mined = true;
        }

        if ((mining_type === "showdown" || mining_type === "interesting_hand") && data.target) {
          this.loadHand({
            room_id: data.target.data.roomId,
            hand_num: data.target.data.hand_num
          })
        }

      }).catch((err) => {
        console.error(err);
      })
    },

    addMessage(messages, payload) {
      let msg = payload.data;
      let server_ts = payload.server_ts;
      let ts = new Date();
      if (server_ts) {
        ts = new Date(server_ts * 1000);
      }

      let read = Boolean(msg.read);
      messages.push({
        'room_id': msg.roomId,
        'type': payload.type || 'group',
        'ts': ts,
        'text': msg.text,
        'name': msg.displayName,
        'read': read,
        'result': msg.result || 0,
        'senderName': msg.sent_by ? msg.sent_by.user : null,
        'hand_num': payload.type === "handend" ? msg.hand_num || -1 : -1,
        'group': msg.group !== false,
        'senderId': msg.senderId,
        'senderType': msg.senderType,
        '_id': payload._id
      });
    },

    openVerifySuggestion(item) {
      this.askVerifySuggestion = true;
      this.verifyingSuggestion = {...item};
    },

    openDeleteSuggestion(item) {
      this.askDeleteSuggestion = true;
      this.deletingSuggestion = {...item};
    },

    openVerifyTrigger(item) {
      this.askVerifyTrigger = true;
      this.verifyingTrigger = {...item};
    },

    openDeleteTrigger(item) {
      this.askDeleteTrigger = true;
      this.deletingTrigger = {...item};
    },

    verifyAllTriggers() {
      const payload = {
        verified: true
      }

      for (let trigger of this.triggers) {
        let id = trigger._id;

        this.$axios.post(`/api/suggestions/triggers/${id}`, payload).then(() => {

        }).catch((err) => {
          console.error(err);
        })
      }

      this.loadSuggestionsTriggers();
    },

    verifyAllSuggestions() {
      const payload = {
        verified: true
      }

      for (let suggestion of this.suggestions) {
        let id = suggestion._id;

        this.$axios.post(`/api/suggestions/${id}`, payload).then(() => {

        }).catch((err) => {
          console.error(err);
        })
      }

      this.loadSuggestions();
    },

    verifyTrigger(item) {
      const payload = {
        verified: true
      }

      let id = item._id;

      this.$axios.post(`/api/suggestions/triggers/${id}`, payload).then(() => {
        this.loadSuggestionsTriggers();
      }).catch((err) => {
        console.error(err);
      })
    },

    verifySuggestion(item) {
      const payload = {
        verified: true
      }

      let id = item._id;

      this.$axios.post(`/api/suggestions/${id}`, payload).then(() => {
        this.loadSuggestions();
      }).catch((err) => {
        console.error(err);
      })
    },

    deleteTrigger(item) {
      let id = item._id;

      this.$axios.delete(`/api/suggestions/triggers/${id}`).then(() => {
        this.loadSuggestionsTriggers();
      }).catch((err) => {
        console.error(err);
      })
    },

    deleteSuggestion(item) {
      let id = item._id;

      this.$axios.delete(`/api/suggestions/${id}`).then(() => {
        this.loadSuggestions();
      }).catch((err) => {
        console.error(err);
      })
    },

    updateDone(tgt) {
      if (!tgt) return;

      if (this.mining_type === 'chats_v1') {
          let h = tgt.clientHeight;
          let sh = tgt.scrollHeight;
          let st = tgt.scrollTop;
          if (sh <= h) {
            this.canMarkDone = true;
            return;
          }
          if (st + h + 5 >= sh) {
            this.canMarkDone = true;
            return;
          }

          this.canMarkDone = false;
          return;
      }

      // for new mining, always can mark done
      this.canMarkDone = true;
    },

    loadAfterAction() {
      this.loadSuggestions();
      this.loadSuggestionsTriggers();
    },

    openEditSuggestion(item) {
      this.askEditSuggestion = true;
      this.editingSuggestion = {...item};
    },

    editSuggestion() {
      const payload = {
        type: this.editingSuggestion.type,
        game_type: this.editingSuggestion.game_type,
        suggestion: this.editingSuggestion.suggestion
      }

      let id = this.editingSuggestion._id;

      this.$axios.post(`/api/suggestions/${id}`, payload).then(() => {
        this.loadSuggestions();
      }).catch((err) => {
        console.error(err);
      })
    },

    openEditTrigger(item) {
      this.askEditTrigger = true;
      this.editingTrigger = {...item};
    },

    editTrigger() {
      const payload = {
        type: this.editingTrigger.type,
        game_type: this.editingTrigger.game_type,
        trigger: this.editingTrigger.trigger
      }

      let id = this.editingTrigger._id;

      this.$axios.post(`/api/suggestions/triggers/${id}`, payload).then(() => {
        this.loadSuggestionsTriggers();
      }).catch((err) => {
        console.error(err);
      })
    },

    isValidEdit() {
      if (!this.editingSuggestion) return false;
      if (!this.editingSuggestion.suggestion) return false;
      if (this.editingSuggestion.suggestion.length < 1) return false;
      return true;
    },

    isValidEditTrigger() {
      if (!this.editingTrigger) return false;
      if (!this.editingTrigger.trigger) return false;
      if (this.editingTrigger.trigger.length < 1) return false;
      return true;
    },

    loadSuggestionTypes() {
      this.loadingTypes = true;
      this.$axios.get("/api/suggestions/types").then((res) => {
        const data = res.data;

        this.types = data.types;

        this.suggestionTypes = [];
        for (let type of this.types) {
          this.suggestionTypes.push({
            _id: type._id,
            text: this.getTypeName(type),
            description: type.description,
            value: type.type,
            is_showdown: type.is_showdown,
            filters: type.filters
          })
        }

        this.loadingTypes = false;

        this.filterUpdated();
      }).catch((err) => {
        console.error(err);
      })
    },

    getTypeName(type) {
      if (type.name) {
        return type.name;
      }
      return type.type.charAt(0).toUpperCase() + type.type.slice(1);
    },

    loadHand(data) {
      return axios.get(`/api/hands?room_id=${data.room_id}&hand=${data.hand_num}`).then((res) => {
        const data = res.data;
        this.handData = data.hand;
      });
    },

    filterChanged() {
      if (this.selectedShowdownFilter === null) {
        setTimeout(() => this.filterUpdated(), 100);
      }

      let f = this.suggestionTypes.filter(el => {
        if (el.value === null) return false;
        return el.value === this.selectedShowdownFilter;
      })

      if (!f.length) return;

      f = f[0];

      this.showdownLoserStrengthMax = f.filters.loser_strength_max;
      this.showdownLoserStrengthMin = f.filters.loser_strength_min;
      this.showdownWinnerStrengthMax = f.filters.winner_strength_max;
      this.showdownWinnerStrengthMin = f.filters.winner_strength_min;
      this.showdownPotSizeMax = f.filters.pot_size_max;
      this.showdownPotSizeMin = f.filters.pot_size_min;
      this.showdownGameType = f.filters.game_type;

      if (f.filters.is_interesting_hand === null) {
        this.showdownInterestingHands = -1;
      } else if (f.filters.is_interesting_hand === false) {
        this.showdownInterestingHands = 0;
      } else if (f.filters.is_interesting_hand === true) {
        this.showdownInterestingHands = 1;
      }
    },

    filterUpdated() {
      let filters = this.showdownFilters;

      let f = this.suggestionTypes.filter(el => {
        if (!el.is_showdown) return false;
        if (!el.filters) return false;

        if (filters.is_interesting_hand !== el.filters.is_interesting_hand) return false;
        if (filters.pot_size_min !== el.filters.pot_size_min) return false;
        if (filters.pot_size_max !== el.filters.pot_size_max) return false;
        if (filters.winner_strength_min !== el.filters.winner_strength_min) return false;
        if (filters.winner_strength_max !== el.filters.winner_strength_max) return false;
        if (filters.loser_strength_min !== el.filters.loser_strength_min) return false;
        if (filters.loser_strength_max !== el.filters.loser_strength_max) return false;
        if (filters.game_type !== el.filters.game_type) return false;
        return true;
      })

      if (f.length) {
        this.selectedShowdownFilter = f[0].value;
      } else {
        this.selectedShowdownFilter = null;
      }
    },

    editShowdownFilter(item) {
      this.askEditType = true;
      this.editType = {...item};
      this.editType.name = this.editType.text;
    },

    editFilter() {
      if (!this.editType.name) return;

      const payload = {
        name: this.editType.name,
      }

      let id = this.editType._id;

      this.$axios.post(`/api/suggestions/types/${id}`, payload).then(() => {
        this.loadSuggestionTypes();
      }).catch((err) => {
        console.error(err);
      })
    }
  }
}
</script>

<style scoped>
.panel {
  width: 50%;
  height: 100%;
  position: absolute;
  right: 0;
  margin: 0;

  border-left: 2px solid white;
  background-color: #4c4c4c;

  z-index: 10000;
}

.panel-action {
  width: 40px;
  height: 40px;
  position: absolute;
  top: 10px;
  left: -40px;
  border-radius: 5px 0 0 5px;
  border: 2px solid white;

  background-color: #1e1e1e;
}

.panel-open {

}

.panel-closed {
  right: -50%;
}

.chat-container {
  height: calc(100vh - 48px) !important;
  max-height: calc(100vh - 48px) !important;
}

.chat-container > div {
  height: 100%;
}

.chat-row {
  margin: 0;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}

.chat-row > div {
  padding: 0;
  flex: 1 1 auto;
}

.mh10 {
  height: 10% !important;
  max-height: 10% !important;
}
.mh15 {
  height: 15% !important;
  max-height: 15% !important;
}
.mh20 {
  height: 20% !important;
  max-height: 20% !important;
}
.mh30 {
  height: 30% !important;
  max-height: 30% !important;
}
.mh40 {
  height: 40% !important;
  max-height: 40% !important;
}
.mh50 {
  height: 50% !important;
  max-height: 50% !important;
}
.mh60 {
  height: 60% !important;
  max-height: 60% !important;
}
.mh70 {
  height: 70% !important;
  max-height: 70% !important;
}
.mh80 {
  height: 80% !important;
  max-height: 80% !important;
}
.mh85 {
  height: 85% !important;
  max-height: 85% !important;
}
.mh90 {
  height: 90% !important;
  max-height: 90% !important;
}
.mh100 {
  height: 100% !important;
  max-height: 100% !important;
}

div.v-window__container {
  height: 100% !important;
}

.c-tabs-items {
  height: calc(100% - 48px);
  /*height: 100%;*/
}

.selected {
  border-bottom: 2px solid #00b0ff;
}
</style>
